import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import * as utils from './utils/util'
import { getToken, setToken, removeToken } from './utils/storage'
import styleManager from './utils/style'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VConsole from 'vconsole'

// 引入全局样式
import '@/styles/index.scss'

const searchParams = new URLSearchParams(window.location.search)

if (searchParams.has('dev888')) {
  new VConsole()
}

// 关闭 ResizeObserver 循环报错弹窗
const debounce = (func, wait) => {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

const resizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends resizeObserver {
  constructor(callback) {
    super(debounce(callback, 20));
  }
};

Vue.use(ElementUI)

// 全局注册工具函数
Vue.prototype.$utils = utils

// 全局注册存储工具
Vue.prototype.$storage = {
  getToken,
  setToken,
  removeToken
}

// 全局注册样式管理器
Vue.prototype.$styleManager = styleManager

Vue.config.productionTip = false

/**
 * home--type3 落地页内嵌 Shopify 主题自定义元素（Web Components），非 Vue 组件。
 * 忽略后不再报 Unknown custom element，仍按原生标签渲染（主题脚本未加载时仅为占位 DOM）。
 */
Vue.config.ignoredElements = [
  /-component$/,
  /^slideshow-/,
  /^header-(?:drawer|menu|actions)$/,
  /^overflow-list$/,
  /^search-button$/,
  /^cart-icon$/,
  /^product-card-link$/,
  /^shop-cart-sync$/
]

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
